import React from "react";
import SideNavbar from "../../app/nav/SideNavbar";
import Box from "@mui/material/Box";

const MainLayout = React.memo(
  () => {
    return (
      <Box>
        <SideNavbar
        />
      </Box>
    );
  }
);

export default MainLayout;
